module.exports = __webpack_public_path__ + "static/media/about-us-team.5a1dec3d.png";